import { HTMLAttributes, useState } from 'react';
import { useLocaleContext } from '@/website/contexts/AppContext';
import { useCustomNavigate } from '@/website/hooks/useCustomNavigate';
import { Routes } from '@/website/util/routes';
import { JoveButton, JoveSliderTabs } from '@jove-frontend/mui';
import { EuropeanUnionList, useJoveBreakpoint } from '@jove-frontend/uikit';
import { Box } from '@mui/material';
import clsx from 'clsx';
import ActurisView, { BrokerActurisGetQuotesInterface } from './acturis';
import JoveView, { BrokerJoveGetQuotesInterface } from './jove';

const JOVE_TAB_KEY = 'jove';
const ACTURIS_TAB_KEY = 'acturis';

type BrokerGetQuotesInfo = BrokerActurisGetQuotesInterface &
  BrokerJoveGetQuotesInterface & {
    activateBrokerAccessButtonText: string;
  };

type BrokerGetQuotesViewProps = HTMLAttributes<HTMLDivElement> & {
  info: BrokerGetQuotesInfo;
};

const BrokerGetQuotesView = (props: BrokerGetQuotesViewProps) => {
  const { className, info } = props;
  const { country } = useLocaleContext();
  const { isMobileLayout } = useJoveBreakpoint();
  const [tabList, setTabList] = useState(
    EuropeanUnionList.includes(country)
      ? [
          {
            value: JOVE_TAB_KEY,
          },
          {
            value: ACTURIS_TAB_KEY,
          },
        ]
      : [
          {
            value: ACTURIS_TAB_KEY,
          },
          {
            value: JOVE_TAB_KEY,
          },
        ]
  );
  const [selectTab, setSelectTab] = useState(tabList[0].value);
  const { push } = useCustomNavigate();

  /**
   * methods
   */
  const tabChangeAction = (value) => {
    setSelectTab(value);
  };

  const goToBrokerOnboardingAction = () => {
    push({ path: Routes.brokerOnboardingSubmit() });
  };

  return (
    <Box className={clsx('flex flex-col items-center', className)}>
      <Box className={clsx('flex flex-col items-center', isMobileLayout ? 'w-full space-y-4' : 'w-[960px] space-y-12')}>
        {isMobileLayout ? (
          <Box className="flex w-full flex-col space-y-3">
            <ActurisView info={info} />
            <JoveView info={info} />
          </Box>
        ) : (
          <Box className="flex w-full flex-row space-x-12">
            <JoveSliderTabs
              type="circle"
              list={tabList}
              value={selectTab}
              valueChange={tabChangeAction}
              width="16px"
              className="min-h-[400px] w-4"
              direction="column"
            />
            {selectTab === ACTURIS_TAB_KEY && <ActurisView className="flex-1" info={info} />}
            {selectTab === JOVE_TAB_KEY && <JoveView className="flex-1" info={info} />}
          </Box>
        )}
        <JoveButton variant="contained" onClick={goToBrokerOnboardingAction}>
          {info?.activateBrokerAccessButtonText}
        </JoveButton>
      </Box>
    </Box>
  );
};

export default BrokerGetQuotesView;
